var React = require('react');

function IcDownloadThin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3 21L21 21V19L3 19V21ZM17.5858 9.37868L12.7929 14.1716L12.7929 3H10.7929L10.7929 14.1716L6 9.37868L4.58579 10.7929L11.7929 18L19 10.7929L17.5858 9.37868Z","fill":"currentColor"}));
}

IcDownloadThin.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IcDownloadThin;

IcDownloadThin.default = IcDownloadThin;
